module.exports = __webpack_public_path__ + "static/img/1-thumb.4ae97149.jpg";